import Accordion from "./_accordion";
import AddressLookup from "./_addressLookup";
import { ApplicationForm } from "./_formApplication";
import BmiCalculator from "./_bmiCalculator";
import Carousel from "./_carousel";
import ContactForm from "./_formContact";
import ConsentModal from "./_consentModal";
import ClinicOpeningTimes from "./_clinicOpeningTimes";
import GetStartedForm from "./_formGetStarted";
import Intent from "./_intent";
import MapEmbed from "./_map";
import NavBar from "./_navBar";
import NavOverlay from "./_navOverlay";
import NewsletterForm from "./_formNewsletter";
import { Overlay } from "./_overlay";
import RequestCallbackForm from "./_formRequestCallback";

const run = (func) => {
    try {
        func();
    } catch (e) {
        console.error(e);
    }
};

const initApp = () => {
    run(Accordion);
    run(AddressLookup);
    run(ApplicationForm);
    run(BmiCalculator);
    run(Carousel);
    run(ClinicOpeningTimes);
    run(ConsentModal);
    run(ContactForm);
    run(GetStartedForm);
    run(Intent);
    run(MapEmbed);
    run(NavBar);
    run(NavOverlay);
    run(NewsletterForm);
    run(Overlay);
    run(RequestCallbackForm);
};

if (document.readyState === "interactive") {
    initApp();
} else {
    window.addEventListener("DOMContentLoaded", initApp, false);
}
